import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import {
  ClubsEntityNormalized,
  DynamicCustomFiltersProps,
} from '../../../../../../../../store/product/types';
import { transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import { deadlineMonthsFilter, legacyAmountFilter } from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { ClubsAsset } from './index';

export const clubsTableHead: TableHeadItemRecurse<ClubsEntityNormalized>[] = [
  { title: '', flex: 0.5 },
  { title: 'Gestor', orderValue: 'managerNameNormalized', flex: 2 },
  { title: 'Nome do clube', orderValue: 'clubNameNormalized', flex: 3 },
  { title: 'Aplicação mín.', orderValue: 'minimumApplication', flex: 2 },
  { title: 'Horário limite', orderValue: 'cutoffTime', flex: 1 },
  { title: '' },
];

export const clubsConstants = {
  id: 'clubs',
  typeGetterId: 'clubs',
  title: 'Clubes',
  operationId: 1,
  operationName: 'Compra',
  operationType: 'buy' as OperationType,
  color: 'product.clubes' as ColorTypes.Option,
  principalComponent: ClubsAsset,
  tableHead: clubsTableHead,
  hideTableHead: false,
  marketStatusSelector: emptyMarketStatusQuery,
  hasFilters: false,
  categoriesField: '',
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [...transformCustomFilters(customFilters), legacyAmountFilter, deadlineMonthsFilter];
  },
  hasCategories: false,
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  captions: [] as AssetCaptionType[],
  unleashFlag: '',
  unleashFlagBatchTicket: '',
  unleashFlagCustomers: Constant.UnleashCustomersClubsToggle,
} as const;
